import chalk from 'chalk';

let pluginName = '';

/** Defines name of plugin to distinguish logs in DEBUG mode. */
const definePluginName = (name) =>
	void (pluginName = name);

/** Convert Error to string. */
const errorToString = (error) =>
	error.name + ': ' + error.message + '\n' + error.stack;

/**
 * Log _message_ bound with _name_ of the process
 * to terminal.
 *
 * @param paint - function that paint _message_.
 * @param message
 * @param emoji - just for fun :)
 */
const log = (paint, message, emoji) =>
	console.info(
		' ' +
			chalk.black.bgYellowBright(new Date().toLocaleTimeString()) +
			' -> ' +
			chalk.bold.gray(pluginName) +
			': ' +
			paint(message instanceof Error ? errorToString(message) : message) +
			' ' +
			emoji,
	);

/**
 * Alert about starting of process.
 *
 * @param message
 */
const start = (message) => log(chalk.green, message, '🆙');

/**
 * Alert about successful ending of process.
 *
 * @param message
 */
const done = (message) => log(chalk.magenta, message, '🙌');

/**
 * Alert about error that was occurred during process execution.
 *
 * @param message
 */
const oops = (message) => log(chalk.red, message, '💥');

/** Shows warning message. */
const warn = (message) => log(chalk.blue, message, '❗️');

const bold = chalk.bold;

export { bold, definePluginName, done, oops, start, warn };
